import React, { useEffect, useState } from "react";

import { apiCall } from '@app/utils/apiCall';
import { useAuth } from '@app/contexts/AuthContext';
import CspeMonthDetail from "@app/components/2_widgets/cspe/CspeMonthDetail";
import CspeDaysCover from "@app/components/2_widgets/cspe/CspeDaysCover";
import CspeVentilation from "@app/components/2_widgets/cspe/CspeVentilation";
import { useDossier } from "@app/contexts/DossierContext";

/**
 * Display the cspe details for a specific structure 
 * @returns 
 */
export default function CspeDetails({structureDataId}) {
    const [loaded, setLoaded] = useState(false);
    const [cspeRecords, setCspeRecords] = useState([]);

    const auth = useAuth();
    const dossier = useDossier();

    if (!loaded && structureDataId) {        
        apiCall({
            method: "get",
            path: `/api/v1/cspe_records?structure_data_id=${structureDataId}`,
            auth: auth,
            onSuccess: (response) => {
                setLoaded(true);
                setCspeRecords(response.data.cspe_records);
            }
        });
    }        
    
    useEffect(() => {
        setLoaded(false);
    }, [structureDataId, dossier]);

    // Group cspe records by monthes
    const groupedAndSorted = sortMonthsChronologically(groupByMonth(cspeRecords));

    function displayCspeMonthRecord(cspeRecordbyMonth, index) {
        return (
            <CspeMonthDetail 
                key={index}
                cspeRecordbyMonth={cspeRecordbyMonth}
                structureDataId={structureDataId}
                reload={() => setLoaded(false) }
            />
        )
    }

    return (
        <div>
            <CspeDaysCover cspeRecords={cspeRecords} />
            <p className="custom-row">
                Les taux officiels sont pré-remplis. Modifiez uniquement si le taux facturé diffère                
            </p>
            <div className="row-title">
                <div className="row mb-3 mt-5">
                <div className="col-5"><span>PÉRIODE</span></div>
                <div className="col-1"><span>EN VIGUEUR</span></div>
                <div className="col-1"><span>APPLIQUÉ</span></div>
                <div className="col-1"><span>STATUT</span></div>
            </div>
            </div>            
            {groupedAndSorted.map(displayCspeMonthRecord)}
            <CspeVentilation structureDataId={structureDataId} loaded={loaded}/>
        </div>
    )
}

/**
 * Group the records by month (based on start_date)
 * @param {*} records 
 * @returns 
 */
const groupByMonth = (records) => {
    const grouped = {};

    records.forEach((record) => {
        const startDate = new Date(record.start_date);
        const monthKey = `${String(startDate.getMonth() + 1).padStart(2, '0')}-${startDate.getFullYear()}`;

        if (!grouped[monthKey]) {
        grouped[monthKey] = [];
        }
        grouped[monthKey].push(record);
    });

    return grouped;
};

/**
 * Sort the array of months chronologically
 * @param {*} grouped 
 * @returns 
 */
const sortMonthsChronologically = (grouped) => {
    const sortedKeys = Object.keys(grouped).sort((a, b) => {
        const [monthA, yearA] = a.split('-').map(Number);
        const [monthB, yearB] = b.split('-').map(Number);
        return yearA - yearB || monthA - monthB;
    });

    return sortedKeys.map((key) => ({ month: key, records: grouped[key] }));
};